import { render, staticRenderFns } from "./Mural.vue?vue&type=template&id=fecb31ea&scoped=true"
import script from "./Mural.vue?vue&type=script&lang=js"
export * from "./Mural.vue?vue&type=script&lang=js"
import style0 from "./Mural.vue?vue&type=style&index=0&id=fecb31ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecb31ea",
  null
  
)

export default component.exports